module.exports = __webpack_public_path__ + "media/images/products/shop/9-10f156803062e00f7e07ee062ac603a9.jpg";